/**
 * 生产环境：prod
 * 开发环境：dev
 * 测试环境：test
 * 预发布环境：pre
 * mock环境：mock
 * @type {string}
 */
/* 区域需要配置的信息包括：BaseURL、oss地址、告知单地址 */
// 环境参数
// TODO: 确认环境
export const ENV = 'prod'
// export const ENV = 'dev'
// export const ENV = 'test'
// const AREA = 'binjiang'
const AREA = 'wuzhou'
// 请求成功对应的码
export const ERR_OK = 200
export const APP_SERVER = 'http://k2dvpr.natappfree.cc'
// 微信获取code服务器地址
export const WECHAT_SERVER = 'https://open.weixin.qq.com/connect/oauth2/authorize'
// token失效对应的码
export const AUTH_FAIL = '401'
// 高德地图api——key
export const MAP_KEY = '7425926154273ff205679b7da02fad55'
// 高德服务api——key
export const MAP_SERVICE_KEY = '8e09b6fbb1b95c0021d6c7822cba35e6'
// 开发环境令牌
export const DEBUG_AUTH = '?debugUserId=oAIed0b7-BiDzrX9cAJqNO2vafHg'
// 接口地址base
const API_BASE_URL_AREA_DICT = {
  'binjiang': {
    'prod': 'http://bjjj.lujingkeji.cn/api',
    'test': 'http://bjjj-test2.lujingkeji.cn/api'
  },
  'wuzhou': {
    // 'prod': 'http://yuyue.lujingkeji.com/wfjbApi_v2',
    'prod': 'http://hnczjb.lujingkeji.com/wfjbApi_v2',
    // 'prod': 'http://gxwzjb.lujingkeji.com/wfjbApi_v2',
    'test': 'http://report.lujingkeji.com/wfjbApi'
  }
}
const API_BASE_URL_DICT = {
  'dev': './wfjbApi', // 开发环境
  // 'prod': 'https://wfjb.police.hangzhou.gov.cn:7443/wfjb-front-api',
  'prod': 'https://ykjj.wfjb.jj-cloud.cn/wfjb-front-api',
  // 'prod': 'https://hsjj.wfjb.jj-cloud.cn:23116/wfjb-front-api',
  // 'prod': 'http://192.168.0.151:19090/wfjb-front-api/',
  // 'prod': 'https://wfjb.police.hangzhou.gov.cn:7443/wfjb-front-api-test',
  'test': 'https://wfjb.police.hangzhou.gov.cn:7443//wfjb-front-api',
  'mock': 'http://192.168.0.151:7300/mock/5cdb698b0a98d03f0485ce4e' // mock环境
}
// 公众号字典
const WECHAT_APPID_AREA_DICT = {
  'binjiang': 'wxa4959a5fa3f0fd36',
  'wuzhou': 'wxe8e85a772e516541'
}
const WECHAT_APPID_DICT = {
  // 滨江交警公众号
  'prod': WECHAT_APPID_AREA_DICT[AREA],
  'dev': 'wxd0f7b89402ade2da', // sundong
  // 测试环境公众号
  'test': 'wx677ff19524a45c7d', // 口袋车管
  // 'test': 'wx6408b0c792dd4929', // my
  'mock': ''
}
// 区域名称字典
const AREA_NAME_DICT = {
  'binjiang': '滨江区',
  'wuzhou': '梧州市'
}
// 部门名称字典
const DEPT_NAME_DICT = {
  'binjiang': '滨江交警大队',
  'wuzhou': '梧州市公安局交通警察支队'
}
// 部门电话地点
const DEPT_TEL_DICT = {
  'binjiang': '0571-86621777',
  'wuzhou': '0774-2063700'
}
// baseURL
export const BASE_URL = API_BASE_URL_DICT[ENV]
// 上传图片地址
export const IMG_SERVER = BASE_URL + '/file/upload'
// 展示图片地址
// export const IMG_SHOW_SERVER = IMG_SHOW_SERVER_DICT[ENV] + (ENV === 'dev' ? DEBUG_AUTH : '')
export const IMG_SHOW_SERVER = BASE_URL + '/p/download/'
// 微信appid
export const WECHAT_APPID = WECHAT_APPID_DICT[ENV]
// 微信appsecret
export const WECHAT_APPID_SECRET = '4cc291b335b21f97ff35eefec549b24f'
// 区域名称
export const AREA_NAME = AREA_NAME_DICT[AREA]
// 部门名称
export const DEPT_NAME = DEPT_NAME_DICT[AREA]
// 部门电话
export const DEPT_TEL = DEPT_TEL_DICT[AREA]



// WEBPACK FOOTER //
// ./src/consts/const.js